const Activity = (props) => {
  return {
    id: props.id,
    name: props.nombre,
    description: props.descripcion,
  };
};

export default Activity;
